import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EmailAddresses, EmailTags } from '../email-tags.service';

@Component({
    selector: 'email-tags-input',
    templateUrl: './email-tags-input.component.html',
    styleUrls: ['./email-tags-input.component.scss'],
    standalone: false
})
export class EmailTagsInputComponent implements OnInit {

  @Input() emailTags: EmailTags
  @ViewChild("toInput", {static: false}) toInput: any

  constructor() { }

  ngOnInit() {}

  public isItemClicked: boolean = false

  public itemClicked(item: EmailAddresses){
    this.isItemClicked = true
    this.toInput.nativeElement.focus()
    this.emailTags.addTag(item)
  }

  blur(){
    setTimeout(() => {
      if(this.isItemClicked) return this.isItemClicked = false
      this.emailTags.focused = false

      if(this.emailTags.searchText) this.emailTags.addTag({firstName: '', lastName: '', email: this.emailTags.searchText})

    }, 150);
  }

}
